import React from "react";
import ReactEcharts from "echarts-for-react";

// import Styles from "components/VOCVOIProgressionChart/BarChartBase.module.css";
// import { CSVLink } from "react-csv";
const BarChartBase = ({
    textLiterals,
    data,
    isLoading
}) => {
    // const [isLoading, setIsLoading] = React.useState(true);
    // const monthNameList = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    // const csvLink = React.useRef();
    // Update Line Graph settings based on scale
    const [width, setWidth] = React.useState(window.innerWidth);
    const [isSmallScreen, setIsSmallScreen] = React.useState(width < 1200);
    const updateDimensions = () => {
        setWidth(window.innerWidth);
        setIsSmallScreen(window.innerWidth < 1200);
    };
    React.useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);

    // Polling data
    const [yAxisLabel, setYAxisLabel] = React.useState("序列数目");
    const [xAxisLabel, setXAxisLabel] = React.useState("日期");
    // const [data, setData] = React.useState([]);
 
    // const dataStartingIndex = 0;
    // let [delay, setDelay] = React.useState(5000); // 5 seconds
    // React.useEffect(() => {
    //   // console.debug(data);
    //     // setIsLoading(true);
    //     setXAxisLabel("Date");
    //     setYAxisLabel("Count");
    //     // getData(`chart7_primerCheck`, sessionid).then((result) => {
    //     // getPerlData(`histogram_count_per_month`, urlParams).then((result) => {
    //     //     if (result != null) {
    //     //         setData(result);
    //     //         // console.debug('perl data=>', result);
    //     //         // console.debug("before calling getPerlData()...")
    //     //         // getPerlData();
    //     //         // console.debug("after calling getPerlData()...")
                
    //             //  setIsLoading(false);
    //     //         // setDelay(null);
    //     //     }
    //     //     else {
    //     //         setIsLoading(true);
    //     //     }
    //     // });
    // }, [ textLiterals]);

    function addThousandSeparator(value = "") {
      const valueString = value.toString();
      const x = valueString.split(".");
      let x1 = x[0];
      const x2 = x.length > 1 ? "." + x[1] : "";
      const rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1,$2");
      }
      return x1.concat(x2);
    }

    function buildSeries(data) {
        const series = [];
        series.push({
            type: "bar",
            hoverAnimation: false,
            data: data.map(item => { return item.c }),
            // barCategoryGap: 10,
            itemStyle: {
                normal: {
                  color: '#0ba3da',
                  borderColor: '#0ba3da'
                }
              },
            label: {
                position: 'top',
                show: true,
                distance: 5,
                fontSize: 9,
                formatter: function (value, idx) {
                  return addThousandSeparator(value.data.toString());
                }
            },
            labelLayout: {
              hideOverlap: true
            },
        });
        // }
        return series;
    }
    const series = buildSeries(data);

    // function buildTitles() {
    //     const titles = [];
    //     titles.push({
    //         text: title,
    //         left: "center",
    //     });

    //     return titles;
    // }
    // const titles = buildTitles();
    const option = {
        // title: tiFtles,
        // color: ["#3398DB"],
        toolbox: {
          show: true,
          orient: 'vertical',
          left: 'right',
          top: 'bottom',
            feature: {
              saveAsImage: {
                title: '保存为SVG文件',
                name: 'Count',
                emphasis: {
                  iconStyle: {
                    textPosition: 'top',
                    textFill: '#666',
                    opacity: 1,
                    textAlign:'right',
                    textBackgroundColor: '#fff',
                    textPadding: 3,
                    textBorderRadius: 2
                  }
                },
                type: 'svg'
              },
            }
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
                animation: false,
            },
        },
        grid: [
          {
            left: "15%",
            top:  "5%",
            bottom: "25%",
            right: "10%",
            
          },
        ],
        dataZoom: [
            {
              type: "inside",
              // realtime: true,
              start: 0,
              end: 100,
              xAxisIndex: [0],
            },
            {
              type: "slider",
              show: true,
              // realtime: true,
              start: 0,
              end: 100,
              xAxisIndex: [0],
              top: "89%",
              handleIcon:
                "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
              handleSize: "80%",
              handleStyle: {
                color: "#fff",
                shadowBlur: 3,
                shadowColor: "rgba(0, 0, 0, 0.6)",
                shadowOffsetX: 2,
                shadowOffsetY: 2,
              },
            },
          ],
        xAxis: {
            name: xAxisLabel,
            nameLocation: "middle",
            nameTextStyle: {
                align: "center",
                verticalAlign: "top",
                padding: [10, 0, 0, 0],

            },
            axisLabel:{
              formatter: function (value, index) { // 202001,202002
                // let monthName=monthNameList[parseInt(value.substring(4))-1];
                return value.substring(0,4)+"年"+parseInt(value.substring(4))+"月" ;
              }
            },
            gridIndex: 0,
            type: "category",
            data: data.map(item => { return item.ym }),
            axisTick:{
              intervel: 0
            }
        },
        yAxis: {
            name: yAxisLabel,
            gridIndex: 0,
            nameLocation: "middle",
            nameGap: 25,
            offset: -2,
            nameTextStyle: {
                padding: [0, 0, 10, 0],
            },
            type: 'value',
            axisLabel: {
            //     formatter: '{value}%'
            fontSize: 10,
            }
        },
        // dataset:dataset,
        series: series,
    };
    return (
        
        <ReactEcharts showLoading={isLoading} option={option} opts={{ renderer: 'svg' }}/>
       
   
    );
};

export default BarChartBase;
